import { render, staticRenderFns } from "./Puntuacion.vue?vue&type=template&id=1f3060f8&"
import script from "./Puntuacion.vue?vue&type=script&lang=js&"
export * from "./Puntuacion.vue?vue&type=script&lang=js&"
import style0 from "./Puntuacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports